import {
  associatedLeCountryCodeColumnDefinition,
  associatedLeGoldIdColumnDefinition,
  businessCodeColumnDefinition,
  businessDescriptionColumnDefinition,
  businessUnitColumnDefinition,
  ccDescriptionColumnDefinition,
  ccOverrideColumnDefinition,
  chartNameColumnDefinition,
  companyCodeColumnDefinition,
  connectionNameColumnDefinition,
  costCenterColumnDefinition,
  enabledFlagColumnDefinition,
  functionalCurrencyColumnDefinition,
  overrideTaxCurrencyColumnDefinition,
  homeOfficeCompanyCodeColumnDefinition,
  homeOfficeCountryCodeColumnDefinition,
  ledgerIdColumnDefinition,
  ledgerIdInColumnDefinition,
  ledgerIdOutColumnDefinition,
  ledgerShortNameColumnDefinition,
  legalEntityColumnDefinition,
  leOverrideColumnDefinition,
  productLineColumnDefinition,
  profitCenterColumnDefinition,
  projectColumnDefinition,
  recordFTCColumnDefinition,
  referenceColumnDefinition,
  subledgerFlagColumnDefinition,
  sourceColumnDefinition,
  statCalcColumnDefinition,
  statCurrencyColumnDefinition,
  usShareholderFlagColumnDefinition,
  jeFlagColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
} from '../columnDefinitions';

const companyCodeColumnDefinitions = [
  diagnosticsSeverityColumnDefinition,
  diagnosticWithTooltipColumnDefinition,
  companyCodeColumnDefinition,
  ccDescriptionColumnDefinition,
  enabledFlagColumnDefinition,
  { ...legalEntityColumnDefinition, headerName: 'Legal Entity' },
  { ...businessUnitColumnDefinition, sort: '' },
  chartNameColumnDefinition,
  { ...connectionNameColumnDefinition, field: 'connName' },
  associatedLeCountryCodeColumnDefinition,
  associatedLeGoldIdColumnDefinition,
  functionalCurrencyColumnDefinition,
  overrideTaxCurrencyColumnDefinition,
  homeOfficeCompanyCodeColumnDefinition,
  homeOfficeCountryCodeColumnDefinition,
  recordFTCColumnDefinition,
  usShareholderFlagColumnDefinition,
  businessCodeColumnDefinition,
  businessDescriptionColumnDefinition,
  ledgerIdColumnDefinition,
  ledgerShortNameColumnDefinition,
  sourceColumnDefinition,
  subledgerFlagColumnDefinition,
  statCalcColumnDefinition,
  statCurrencyColumnDefinition,
  costCenterColumnDefinition,
  {
    ...projectColumnDefinition,
    field: 'project',
  },
  referenceColumnDefinition,
  productLineColumnDefinition,
  profitCenterColumnDefinition,
  ledgerIdInColumnDefinition,
  ledgerIdOutColumnDefinition,
  leOverrideColumnDefinition,
  ccOverrideColumnDefinition,
  jeFlagColumnDefinition,
];

export default companyCodeColumnDefinitions;

export const exportCompanyCodeColumnDefs = [
  diagnosticsSeverityColumnDefinition,
  diagnosticColumnDefinition,
  ...companyCodeColumnDefinitions.slice(2),
];

export const importCompanyCodeColumnDefs = companyCodeColumnDefinitions.slice(2);

export const adminExportCompanyCodeColumnDefs = [
  companyCodeColumnDefinition,
  ccDescriptionColumnDefinition,
  enabledFlagColumnDefinition,
  { ...legalEntityColumnDefinition, headerName: 'Legal Entity' },
  { ...businessUnitColumnDefinition, sort: '' },
  chartNameColumnDefinition,
  { ...connectionNameColumnDefinition, field: 'connName' },
  associatedLeCountryCodeColumnDefinition,
  associatedLeGoldIdColumnDefinition,
  functionalCurrencyColumnDefinition,
  overrideTaxCurrencyColumnDefinition,
  homeOfficeCompanyCodeColumnDefinition,
  homeOfficeCountryCodeColumnDefinition,
  recordFTCColumnDefinition,
  usShareholderFlagColumnDefinition,
  businessCodeColumnDefinition,
  businessDescriptionColumnDefinition,
  ledgerIdColumnDefinition,
  ledgerShortNameColumnDefinition,
  sourceColumnDefinition,
  subledgerFlagColumnDefinition,
  statCalcColumnDefinition,
  statCurrencyColumnDefinition,
];
